import {AppleBusiness} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/applebusiness';
import {AppleCountryInfo} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/applecountryinfo';
import {GbpGroup} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/gbpgroup';
import {GetAppleCountryInfosResponse} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/getapplecountryinfosresponse';
import {GetGbpGroupLocationsResponse} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/getgbpgrouplocationsresponse';
import {GetGbpGroupsResponse} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/getgbpgroupsresponse';
import {GetSyncedFieldSettingsResponse} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/getsyncedfieldsettingsresponse';
import {GetSyncedFieldsResponse} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/getsyncedfieldsresponse';
import {LinkedAccount} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/linkedaccount';
import {OverrideField} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/overridefield';
import {OverrideFieldKey} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/overridefieldkey';
import {OverrideFieldType} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/overridefieldtype';
import {SyncedField} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/syncedfield';
import {SyncedFieldKey} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/syncedfieldkey';
import {SyncedFieldSetting} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/syncedfieldsetting';
import {ValidateFacebookBrandResponse} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/validatefacebookbrandresponse';
import {ValidateGbpGroupResponse} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/validategbpgroupresponse';

export const mockSyncedFieldKey1 = new SyncedFieldKey({id: 1, typeId: 1});
export const mockSyncedFieldKey2 = new SyncedFieldKey({id: 2, typeId: 2});
export const mockSyncedFieldKey3 = new SyncedFieldKey({id: 3, typeId: 3});
export const mockSyncedFieldKey4 = new SyncedFieldKey({id: 4, typeId: 4});

export const mockOverrideFieldKey1 = new OverrideFieldKey({id: 1, type: OverrideFieldType.BUILTIN});
export const mockOverrideFieldKey2 = new OverrideFieldKey({id: 2, type: OverrideFieldType.CUSTOM});
export const mockOverrideFieldKey3 = new OverrideFieldKey({id: 3, type: OverrideFieldType.NONE});

export const mockOverrideField1 = new OverrideField({key: mockOverrideFieldKey1, name: 'override field name 1'});
export const mockOverrideField2 = new OverrideField({key: mockOverrideFieldKey2, name: 'override field name 2'});
export const mockOverrideField3 = new OverrideField({key: mockOverrideFieldKey3, name: 'override field name 3'});

export const mockSyncedField1 =
    new SyncedField({
      key: mockSyncedFieldKey1,
      order: 4,
      name: 'Synced Field 1',
      description: 'description 1',
      canOverwriteData: true,
      overrideFields: [mockOverrideField1],
    });
export const mockSyncedField2 =
    new SyncedField({
      key: mockSyncedFieldKey2,
      order: 3,
      name: 'Synced Field 2',
      description: undefined,
      canOverwriteData: true,
      overrideFields: [mockOverrideField2],
    });
export const mockSyncedField3 =
    new SyncedField({
      key: mockSyncedFieldKey3,
      order: 2,
      name: 'Synced Field 3',
      description: 'description 3',
      canOverwriteData: false,
      overrideFields: [mockOverrideField3],
    });
export const mockSyncedField4 =
    new SyncedField({
      key: mockSyncedFieldKey4,
      order: 1,
      name: 'Synced Field 4',
      description: undefined,
      canOverwriteData: false,
      overrideFields: [],
    });

export const mockSyncedFieldSetting1 =
    new SyncedFieldSetting({
      syncedFieldKey: mockSyncedFieldKey1,
      overrideFieldKey: mockOverrideFieldKey1,
      enabled: true,
      replaceExisting: true,
      applyToNewSubAccounts: false,
    });
export const mockSyncedFieldSetting2 =
  new SyncedFieldSetting({
    syncedFieldKey: mockSyncedFieldKey2,
    overrideFieldKey: undefined,
    enabled: true,
    replaceExisting: true,
    applyToNewSubAccounts: false,
  });
export const mockSyncedFieldSetting3 =
  new SyncedFieldSetting({
    syncedFieldKey: mockSyncedFieldKey3,
    overrideFieldKey: mockOverrideFieldKey3,
    enabled: true,
    replaceExisting: false,
    applyToNewSubAccounts: true,
  });
export const mockSyncedFieldSetting4 =
  new SyncedFieldSetting({
    syncedFieldKey: mockSyncedFieldKey4,
    overrideFieldKey: undefined,
    enabled: false,
    replaceExisting: false,
    applyToNewSubAccounts: true,
  });


export const mockGetSyncedFieldSettingsResponse =
  new GetSyncedFieldSettingsResponse({
    settings: [mockSyncedFieldSetting1, mockSyncedFieldSetting2, mockSyncedFieldSetting3, mockSyncedFieldSetting4],
  });

export const mockGetSyncedFieldsResponse =
  new GetSyncedFieldsResponse({
    fields: [mockSyncedField1, mockSyncedField2, mockSyncedField3, mockSyncedField4],
  });

export const mockValidateFacebookBrandsResponse = new ValidateFacebookBrandResponse({valid: true});
export const mockValidateFacebookBrandsResponseInvalid = new ValidateFacebookBrandResponse({valid: false});

export const mockGbpGroup1 = new GbpGroup({id: '1', name: 'GBP Group 1'});
export const mockGbpGroup2 = new GbpGroup({id: '2', name: 'GBP Group 2'});
export const mockGetGbpGroupsResponse = new GetGbpGroupsResponse({groups: [mockGbpGroup1, mockGbpGroup2], useTextInput: false});
export const mockGetGbpGroupsResponseUseTextInput = new GetGbpGroupsResponse({groups: [mockGbpGroup1, mockGbpGroup2], useTextInput: true});

const mockGbpGroupId1 = '1';
const mockGbpGroupId2 = '2';

export const mockGetGbpGroupLocationsResponse = new GetGbpGroupLocationsResponse({
  gbpAccountToLocationCount: new Map([[mockGbpGroupId1, 10], [mockGbpGroupId2, 5]]),
});

export const mockValidateGbpGroupResponse = new ValidateGbpGroupResponse({valid: true});
export const mockValidateGbpGroupResponseInvalid = new ValidateGbpGroupResponse({valid: false});

export const mockAppleBusiness1 = new AppleBusiness({
  displayName: 'Business 1',
  appleBusinessId: '123',
});

export const mockAppleBusiness2 = new AppleBusiness({
  displayName: 'Business 2',
  appleBusinessId: '789',
});

export const mockAppleCountryInfo = new AppleCountryInfo({
  country: 'US',
  appleCompanyId: '12345',
  appleBusinesses: [mockAppleBusiness1, mockAppleBusiness2],
  selectedAppleBusiness: undefined,
  excluded: false,
});

export const mockAppleCountryInfo2 = new AppleCountryInfo({
  country: 'CA',
  appleCompanyId: '67890',
  appleBusinesses: [mockAppleBusiness1],
  selectedAppleBusiness: undefined,
  excluded: false,
});

export const mockGetAppleCountryInfosResponse =
  new GetAppleCountryInfosResponse({
    appleCountryInfos: [mockAppleCountryInfo, mockAppleCountryInfo2],
  });

export const mockLinkedAccounts = [
  new LinkedAccount({
    id: 1,
    name: 'linked account 1',
    emailAddress: 'email address 1',
  }),
  new LinkedAccount({
    id: 2,
    name: 'linked account 2',
    emailAddress: 'email address 2',
  }),
];
